/**
 * Push Notification Service
 * Χειρίζεται την εγγραφή του browser για push notifications
 */

const VAPID_PUBLIC_KEY = 'BKdMgH_QBL9bxsaWQ4tddYJVNnNGPIZoboHJOYVXd-12MQZUdZ_PKEwisp0mg-TXDK-AnusuIpMCvDTbrG4-vXI'

function urlBase64ToUint8Array(base64String: string): ArrayBuffer {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const rawData = atob(base64)
  const buffer = new ArrayBuffer(rawData.length)
  const output = new Uint8Array(buffer)
  for (let i = 0; i < rawData.length; i++) {
    output[i] = rawData.charCodeAt(i)
  }
  return buffer
}

/**
 * Ζητά άδεια και εγγράφει τη συσκευή για push notifications.
 * Καλείται μόνο αφού ο χρήστης έχει κάνει login.
 */
export async function subscribeToPush(): Promise<boolean> {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.warn('[Push] Δεν υποστηρίζεται από αυτόν τον browser.')
    return false
  }

  try {
    const registration = await navigator.serviceWorker.ready

    // Έλεγχος αν υπάρχει ήδη subscription
    const existingSub = await registration.pushManager.getSubscription()
    if (existingSub) {
      await saveSubscriptionToServer(existingSub)
      return true
    }

    // Ζήτηση άδειας
    const permission = await Notification.requestPermission()
    if (permission !== 'granted') {
      console.warn('[Push] Άδεια αρνήθηκε.')
      return false
    }

    // Εγγραφή
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    })

    await saveSubscriptionToServer(subscription)
    console.log('[Push] Εγγραφή επιτυχής.')
    return true
  } catch (err) {
    console.error('[Push] Σφάλμα εγγραφής:', err)
    return false
  }
}

async function saveSubscriptionToServer(subscription: PushSubscription): Promise<void> {
  const response = await fetch('/backend/push/subscribe.php', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ subscription: subscription.toJSON() }),
  })

  if (!response.ok) {
    throw new Error(`Server error: ${response.status}`)
  }
}

/**
 * Ακυρώνει το push subscription (χρήσιμο στο logout)
 */
export async function unsubscribeFromPush(): Promise<void> {
  if (!('serviceWorker' in navigator)) return

  const registration = await navigator.serviceWorker.ready
  const subscription = await registration.pushManager.getSubscription()
  if (subscription) {
    await subscription.unsubscribe()
  }
}

/**
 * Καθαρίζει το badge στο icon της εφαρμογής
 */
export function clearAppBadge(): void {
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({ type: 'CLEAR_BADGE' })
  }
  ;(navigator as any).clearAppBadge?.()
}
